<app-card class="card-container">
  <app-list
    class="filter-list"
    [items]="filtersObservable | async"
    keyExpr="id"
  >
    <ng-template listItem let-item="item">
      <div class="filter-item">
        <div class="content">
          <app-filter-text [item]="item" [fields]="fields"></app-filter-text>
        </div>
      </div>
    </ng-template>
  </app-list>

  <div class="bottom-section">
    <div class="icon-filter-item">
      <app-iconic class="icon" icon="assets/icons/filter.svg"></app-iconic>
    </div>

    <div class="btn-remove-filters-item" #btnRemoveFiltersItemEl>
      <app-button
        buttonType="danger"
        styleType="text"
        shapeType="circle"
        sizeType="normal"
        icon="assets/icons/trash.svg"
        (click)="onBtnRemoveFiltersClick()"
      ></app-button>

      <app-tooltip
        [target]="btnRemoveFiltersItemEl"
        verticalAlignment="top"
        horizontalAlignment="center"
      >
        Remover filtros
      </app-tooltip>
    </div>
  </div>
</app-card>
